<template>
  <div class="import-jobs">
    <ImportJobsFromFile @update="() => $emit('update')"/>
    <el-button
      size="small"
      style="width: 100%"
      class="add-new-object"
      @click="dialogObject = true"
    >
      Импортировать {{ name }}
    </el-button>

    <el-dialog :title="`Импортировать ${ name }`" :visible.sync="dialogObject">
      <ImportJobsContent @clear="clear" @update="$emit('update')" v-if="dialogObject"/>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import {getChildList} from '../../../../utils/getChild';
import ImportJobsFromFile from './ImportJobsFromFile';
import ImportJobsContent from "./ImportJobsContent";

export default {
  name: 'ImportJobs',
  components: {ImportJobsContent, ImportJobsFromFile},
  props: ['name'],
  data() {
    return {
      dialogObject: false,
    };
  },
  methods: {
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.objectId = null;
      this.selected = null;
    },
  },
};
</script>

<style scoped lang="scss">
.import-jobs {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
}

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.create-footer {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 500px) {
  .import-jobs {
    display: flex;
    flex-direction: column !important;
    height: 84px  !important;
    justify-content: space-between  !important;
    >>> button {
      width: 100%;
    }

    >>> .el-dialog__headerbtn {
      width: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/components/Importjobs.vue